
export default function VideoSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block mb-4 px-4 md:px-6 py-2 bg-teal-50 border border-teal-200 rounded-full">
            <span className="text-teal-600 font-semibold tracking-wider text-xs md:text-sm uppercase">
              Video Resources
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            Related <span className="text-teal-600">Video Resources</span>
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            ROBO Asset Grid&apos;s technology and major news coverage on water meters
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-10 md:space-y-16">
          {/* News Video */}
          <div>
            <div className="text-center mb-6 md:mb-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900">
                Related News Coverage
              </h3>
              <p className="text-xs md:text-base text-gray-600 mt-2">
                News coverage on water meter lead content issues and lack of regulations
              </p>
            </div>

            <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
              <div className="relative aspect-video w-full">
                <iframe
                  src="https://www.youtube.com/embed/DrR08OJZk1Q?si=YlHqOIk9VKVoUU1Q"
                  title="Water Meter Lead Content News Coverage"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>

              {/* Video Info */}
              <div className="p-4 md:p-8 bg-gray-50">
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="flex-shrink-0 hidden sm:block">
                    <div className="w-12 md:w-16 h-12 md:h-16 bg-red-100 rounded-xl flex items-center justify-center">
                      <i className="ri-alert-line text-2xl md:text-3xl text-red-600"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                      Key Coverage Points
                    </h4>
                    <ul className="space-y-2 text-xs md:text-base text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>Lead content exceeding standards detected in household water meters</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>Lack of domestic water meter lead content regulatory standards</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-red-600 mt-0.5 flex-shrink-0"></i>
                        <span>US limits to 0.25% or less, Europe bans lead content entirely</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional News Video */}
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
            <div className="relative aspect-video w-full">
              <iframe
                src="https://www.youtube.com/embed/CLKhnB94sKA?si=cxcClYKX6wzhbbPR"
                title="Additional Water Meter News Coverage"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>

            {/* Video Info */}
            <div className="p-4 md:p-8 bg-gradient-to-r from-gray-50 to-slate-50">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="flex-shrink-0 hidden sm:block">
                  <div className="w-12 md:w-16 h-12 md:h-16 bg-orange-100 rounded-xl flex items-center justify-center">
                    <i className="ri-newspaper-line text-2xl md:text-3xl text-orange-600"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                    Related News Coverage
                  </h4>
                  <p className="text-xs md:text-base text-gray-600 leading-relaxed">
                    Additional news coverage related to water meter lead content issues.
                    Learn about the need for regulations to protect public health and safety.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Company Promotional Video */}
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
            <div className="relative aspect-video w-full">
              <iframe
                src="https://www.youtube.com/embed/ey5On3dFI5Y?si=tFSd6K8E3_tl-IoE"
                title="ROBO Asset Grid Test Factory and Research Center Promotional Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>

            {/* Video Info */}
            <div className="p-4 md:p-8 bg-gradient-to-r from-teal-50 to-cyan-50">
              <div className="flex items-start gap-4 md:gap-6">
                <div className="flex-shrink-0 hidden sm:block">
                  <div className="w-12 md:w-16 h-12 md:h-16 bg-teal-100 rounded-xl flex items-center justify-center">
                    <i className="ri-building-2-line text-2xl md:text-3xl text-teal-600"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                    ROBO Asset Grid Test Factory & Research Center
                  </h4>
                  <p className="text-xs md:text-base text-gray-600 leading-relaxed">
                    Introducing ROBO Asset Grid&apos;s state-of-the-art test factory and research center.
                    See our smart water meter development and quality verification facilities based on optical sensing technology.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-lg border border-gray-200">
              <div className="w-10 md:w-12 h-10 md:h-12 bg-red-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-error-warning-line text-xl md:text-2xl text-red-600"></i>
              </div>
              <h5 className="font-bold text-sm md:text-base text-gray-900 mb-1 md:mb-2">
                Lack of Domestic Regulations
              </h5>
              <p className="text-gray-600 text-xs md:text-sm">
                No clear regulatory standards for water meter lead content
              </p>
            </div>

            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-lg border border-gray-200">
              <div className="w-10 md:w-12 h-10 md:h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-global-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h5 className="font-bold text-sm md:text-base text-gray-900 mb-1 md:mb-2">
                International Regulations
              </h5>
              <p className="text-gray-600 text-xs md:text-sm">
                US: 0.25% or less, Europe: Complete ban on lead content
              </p>
            </div>

            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-lg border border-gray-200">
              <div className="w-10 md:w-12 h-10 md:h-12 bg-green-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-shield-check-line text-xl md:text-2xl text-green-600"></i>
              </div>
              <h5 className="font-bold text-sm md:text-base text-gray-900 mb-1 md:mb-2">
                Our Solution
              </h5>
              <p className="text-gray-600 text-xs md:text-sm">
                Complete elimination of lead content issues with stainless steel
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
